import { render, staticRenderFns } from "./DetailItemPics.vue?vue&type=template&id=42c891bf&scoped=true&"
import script from "./DetailItemPics.vue?vue&type=script&lang=js&"
export * from "./DetailItemPics.vue?vue&type=script&lang=js&"
import style0 from "./DetailItemPics.vue?vue&type=style&index=0&id=42c891bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c891bf",
  null
  
)

export default component.exports